import EnterpriseSWIcon from "../../assets/product-list-assets/aggregation.svg";
import type { ProductListGroup } from "../../types";

export const switchingEnterprise: ProductListGroup = {
  id: "switchingEnterprise",
  title: "productListGroup.switchingEnterprise.title",
  seriesLabel: "modelCompare.seriesLabel.switchingEnterprise",
  icon: {
    src: EnterpriseSWIcon,
    width: 22,
    height: 22,
  },
};
